import React, { useEffect, useMemo, useState } from 'react';
import * as styles from './view-report-position-insights.module.scss';
import { arrow_prev } from '../../../../assets/img';
import { BasicButton, BasicTable } from '../../../../assets/common';
import { convertRoleForPosition, handleDownloadFile, paginationConfig } from '../../../../utils/helper';
import { talentAnalyticApi } from '../../../../services/talentAnalyticApi';
import { notification, Spin } from 'antd';
import {
  DEFAULT_CRITICAL_POSITION,
  DEFAULT_SENSITIVE_POSITION,
  POSITION_INSIGHTS_TAB,
  TA_YEARS_OPTIONS,
  CRITICAL_POSITION_CATERORY,
  POSITION_INSIGHTS_REPORT_COLUMNS,
  RANGE_YEAR,
} from '../../talent-analytics.constant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useSelector } from 'react-redux';
import { DATE_TIME_FORMAT, USER_ACCESS_MESSAGE } from '../../../../utils/constants';
import { isEmpty } from 'lodash';
import moment from 'moment';

const ROWS_LIMIT = 20;
const TABLE_STYLE = {
  borderRadius: 6,
};

const ViewReportPositionInsights = ({ reportType, filterMasterData, totalPosition, stackChartData, tabFilters, setStackChartData, showSensitiveOnly }) => {
  const roleActive = useSelector((state) => state.user.roleActive);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [reports, setReports] = useState({
    data: [],
    total: 10,
  });
  const [page, setPage] = useState(1);
  const history = useHistory();

  const handleClickBack = () => {
    setStackChartData((pre) => ({
      ...pre,
      [reportType]: {},
    }));
    history.push(window.location.path);
  };

  const filterApplied = useMemo(() => {
    const filters = [];
    Object.keys(filterMasterData).map((key) => {
      if (filterMasterData[key].length) {
        filters.push(key);
      }
    });
    return filters;
  }, [filterMasterData]);

  const getReportType = useMemo(() => {
    if (isEmpty(reportType)) return '';

    let tempVal = '';
    switch (reportType) {
      // case POSITION_INSIGHTS_TAB[0]:
      //   tempVal = POSITION_INSIGHTS_TAB[0];
      //   break;
      // case POSITION_INSIGHTS_TAB[1]:
      //   tempVal = tabFilters[POSITION_INSIGHTS_TAB[1]];
      //   break;
      case POSITION_INSIGHTS_TAB[0]:
        tempVal = tabFilters[POSITION_INSIGHTS_TAB[0]];
        break;
      case POSITION_INSIGHTS_TAB[1]:
        tempVal = POSITION_INSIGHTS_TAB[1];
        break;
      case POSITION_INSIGHTS_TAB[2]:
        tempVal = POSITION_INSIGHTS_TAB[2];
        break;
      default:
        break;
    }
    return tempVal;
  }, [reportType]);

  useEffect(() => {
    const handleGetReports = async () => {
      try {
        setLoading(true);
        const body = {
          filters: filterMasterData,
          report_type: getReportType,
          page,
          limit: ROWS_LIMIT,
        };

        // if (reportType === POSITION_INSIGHTS_TAB[1]) {
        if (reportType === POSITION_INSIGHTS_TAB[0]) {
          body.range = stackChartData.xAxisName
            ? [
                {
                  value: RANGE_YEAR.find((range) => range.label === stackChartData.xAxisName).value,
                },
              ]
            : RANGE_YEAR.map((year) => ({ value: year.value }));
          body.filters.critical_position_category = stackChartData.stackName
            ? [CRITICAL_POSITION_CATERORY.find((category) => category.value === stackChartData.stackName)]
            : CRITICAL_POSITION_CATERORY;
          body.filters.sensitive_position = [];
        }
        // if (reportType === POSITION_INSIGHTS_TAB[2]) {
        //   const yop = tabFilters[POSITION_INSIGHTS_TAB[2]];
        if (reportType === POSITION_INSIGHTS_TAB[1]) {
          const yop = tabFilters[POSITION_INSIGHTS_TAB[1]];
          body.report_type = 'YEARS_OF_POSITION';
          body.range = [{ value: yop.startYear }];
          body.filters.critical_position_category = stackChartData?.stackName ? [stackChartData?.stackName] : DEFAULT_CRITICAL_POSITION;
          body.filters.sensitive_position = stackChartData?.xAxisName ? [stackChartData?.xAxisName] : showSensitiveOnly ? DEFAULT_SENSITIVE_POSITION.filter(item => item.value !== 'No Level') : DEFAULT_SENSITIVE_POSITION;
        }

        const res = await talentAnalyticApi.fetchReportPositionInsights(body, roleActive.roleId);
        if (res.status === 200) {
          setReports(res.data.result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    handleGetReports();
  }, [page]);

  const handleDownloadReport = async () => {
    try {
      setExporting(true);
      const body = {
        filters: filterMasterData,
        report_type: getReportType,
        page,
        limit: ROWS_LIMIT,
      };

      // if (reportType === POSITION_INSIGHTS_TAB[1]) {
      if (reportType === POSITION_INSIGHTS_TAB[0]) {
        body.range = stackChartData.xAxisName
          ? [
              {
                value: RANGE_YEAR.find((range) => range.label === stackChartData.xAxisName).value,
              },
            ]
          : RANGE_YEAR.map((year) => ({ value: year.value }));
        body.filters.critical_position_category = stackChartData.stackName
          ? [CRITICAL_POSITION_CATERORY.find((category) => category.value === stackChartData.stackName)]
          : CRITICAL_POSITION_CATERORY;
        body.filters.sensitive_position = [];
      }
      // if (reportType === POSITION_INSIGHTS_TAB[2]) {
      //   const yop = tabFilters[POSITION_INSIGHTS_TAB[2]];
      if (reportType === POSITION_INSIGHTS_TAB[1]) {
        const yop = tabFilters[POSITION_INSIGHTS_TAB[1]];
        body.report_type = 'YEARS_OF_POSITION';
        body.range = [{ value: yop.startYear }];
        body.filters.critical_position_category = stackChartData?.stackName ? [stackChartData?.stackName] : DEFAULT_CRITICAL_POSITION;
        body.filters.sensitive_position = stackChartData?.xAxisName ? [stackChartData?.xAxisName] : showSensitiveOnly ? DEFAULT_SENSITIVE_POSITION.filter(item => item.value !== 'No Level') : DEFAULT_SENSITIVE_POSITION;
      }

      const res = await talentAnalyticApi.fetchReportPositionInsightsUrl(body, roleActive.roleId);
      const file = { url: res?.data?.result, file_name: 'Export Position Insights Report' };
      handleDownloadFile(file);
    } catch (error) {
      console.error(error);
      notification.error({
        message: USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR,
        duration: 5,
      });
    } finally {
      setExporting(false);
    }
  };

  const handleConvertValue = (value, column) => {
    if (column?.dataIndex === 'role_level') {
      return convertRoleForPosition(value);
    } else if (column?.dataIndex === 'years_in_position') {
      return value ?? '-';
    } else if (column?.dataIndex === 'approved_date') {
      return value ? moment(value).format(DATE_TIME_FORMAT.DATE_MONTH_YEAR_HYPHEN) : '-';
    } else {
      return value;
    }
  };

  //need to update reportTypeShow in talent-analytics.constant.js when update position insights tab
  const columns = useMemo(() => {
    return POSITION_INSIGHTS_REPORT_COLUMNS.filter(
      (col) =>
        (!col.filterShowName && !col.reportTypeShow) ||
        filterApplied.includes(col.filterShowName) ||
        (col.reportTypeShow && col.reportTypeShow.includes(reportType))
    ).map((col) => ({
      ...col,
      align: col.align || 'center',
      render: (text, record) => {
        const isPositionName = col.dataIndex === 'position_name';
        const isCurrentIncumbent = col.dataIndex === 'current_incumbent';

        if (isPositionName && text)
          return (
            <div
              className={`${styles.text} ${styles.cursor_pointer}`}
              style={col.style}
              onClick={() => window.open(`/succession-planning-dashboard/${record.position_id}`)}
            >
              {text}
            </div>
          );

        if (isCurrentIncumbent && text)
          return (
            <div className={`${styles.text} ${styles.cursor_pointer}`} style={col.style} onClick={() => window.open(`/profile/${record.staff_id}`)}>
              {text}
            </div>
          );

        return (
          <div className={styles.text} style={col.style}>
            {text ? handleConvertValue(text, col) : '-'}
          </div>
        );
      },
    }));
  }, [filterApplied]);

  const pagination = useMemo(() => {
    const onChange = (pageNum) => {
      setPage(pageNum);
    };
    return paginationConfig(reports.total, page, onChange, ROWS_LIMIT);
  }, [reports.total, page]);

  return (
    <div className={styles.wrapper}>
      <button className={styles.btn} onClick={handleClickBack}>
        <img src={arrow_prev} /> <span>Back</span>
      </button>
      <div className={styles.title}>View Report</div>
      <Spin spinning={loading}>
        <div className={styles.content}>
          <div className={styles.topInfo}>
            <div className={styles.info}>
              {/* {reportType === POSITION_INSIGHTS_TAB[2] && ( */}
              {reportType === POSITION_INSIGHTS_TAB[1] && (
                <div style={{ borderRight: '1px solid #cbd6e2' }}>
                  Years Of Position <span>{TA_YEARS_OPTIONS.find((i) => i.value === tabFilters[POSITION_INSIGHTS_TAB[2]]?.startYear)?.label}</span>
                </div>
              )}
              <div>
                Total Position <span>{reportType === POSITION_INSIGHTS_TAB[0] ? reports.total : totalPosition}</span>
              </div>
            </div>
            <Spin spinning={exporting}>
              <BasicButton disabled={!reports.total} mode="teal" onClick={handleDownloadReport}>
                Download Report
              </BasicButton>
            </Spin>
          </div>

          <BasicTable
            rowKey={(record) => `${record.no}`}
            dataSource={reports?.res || []}
            columns={columns}
            pagination={pagination}
            scroll={{ x: 'max-content' }}
            styles={TABLE_STYLE}
          />
        </div>
      </Spin>
    </div>
  );
};

export default ViewReportPositionInsights;
